import type { CatalogSpring } from '@/api/domains'

/**
 * Filter catalog springs by tag, client-side — the builder rail's tag chips.
 * Mirrors the backend `filter_springs_by_tags` (products/diwa/.../catalog.py):
 *
 *  - no selected tags → the pool is returned unchanged (no filter)
 *  - match "any" (default) → keep a spring that carries at least one selected tag
 *  - match "all" → keep only springs that carry every selected tag
 */
export function filterSpringsByTags(
  springs: CatalogSpring[],
  tags: string[],
  match: 'any' | 'all' = 'any',
): CatalogSpring[] {
  if (tags.length === 0) return springs
  const wanted = new Set(tags)
  return springs.filter((sp) => {
    const have = new Set(sp.tags)
    return match === 'all'
      ? [...wanted].every((t) => have.has(t))
      : sp.tags.some((t) => wanted.has(t))
  })
}

/** The distinct tags across a category's springs, sorted — the filter chip row. */
export function tagsOf(springs: CatalogSpring[]): string[] {
  return [...new Set(springs.flatMap((s) => s.tags))].sort()
}
